/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { OverrideData, UnblockDayApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    unblockDay: build.mutation<OverrideData, UnblockDayApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/slots/unblock-day`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as unblockDayApi };
export const { useUnblockDayMutation } = injectedRtkApi;
